module.exports = __webpack_public_path__ + "img/e1724dd.jpg";